import { rgba } from 'polished';
import { styled, css } from 'styled-components';

export const Container = styled.div<{ $isHighlighted: boolean }>`
  ${({ theme: { colors, fontSizes, fontWeights }, $isHighlighted }) => css`
    border-radius: 0.5rem;
    cursor: pointer;
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 0.5rem;
    justify-content: center;
    padding: 0.75rem;
    outline: 1px solid;
    outline-color: ${colors.brandDarkTint95};
    outline-offset: -1px;

    p {
      font-size: ${fontSizes.s12};
      font-weight: ${fontWeights.medium};
      line-height: 1em;
      margin: 0;
      text-align: center;
    }

    &:hover {
      background: ${rgba(colors.brandDarkTint95, 0.5)};
      outline-color: transparent;
    }

    ${
      $isHighlighted &&
      css`
        background: ${colors.brandPrimaryTint95};
        outline-color: ${colors.brandPrimaryTint95};

        &:hover {
          background: ${colors.brandPrimaryTint95};
        }

        p {
          color: ${colors.brandPrimary};
        }
      `
    }
  `}
`;

export const Graph = styled.div`
  align-items: flex-end;
  display: flex;
  gap: 0.5rem;
  justify-content: center;
  height: 2rem;
`;

export const Bar = styled.span<{ $height: number; $isZero: boolean }>`
  ${({ theme: { colors }, $height, $isZero }) => css`
    background: ${colors.brandPrimaryTint20};
    border-radius: 0.125rem;
    display: block;
    width: 0.25rem;
    height: ${$isZero ? `1px` : `${$height}%`};
  `}
`;
